import { api } from '@/api';
import { LinkButton } from '@/components/common';
import { Page } from '@/components/dashboard/page';
import type { Room } from '@shared/modelTypes/room-types';
import { createFileRoute } from '@tanstack/react-router';
import { Code, Heading } from 'ht-sdk/react';
import { Pencil } from 'lucide-react';

export const Route = createFileRoute('/dashboard/rooms/')({
	component: RouteComponent,
	loader: async () => {
		// TODO: fix types so you don't need to pass an empty object
		const rooms = await api.roomList({});
		return { rooms: rooms.success ? rooms.data : [] };
	},
});

function RouteComponent() {
	const data = Route.useLoaderData();

	return (
		<Page>
			<div className="flex flex-row items-center gap-3">
				<Heading>Rooms</Heading>
				<LinkButton iconLeft={Pencil} to="/dashboard/rooms/edit">
					Edit Rooms
				</LinkButton>
			</div>

			<div className="flex flex-col gap-1 overflow-auto pb-8">
				{data.rooms.map((room) => (
					<RoomView key={room.id} room={room} />
				))}
			</div>
		</Page>
	);
}

function RoomView({ room }: { room: Room }) {
	return (
		<div className="flex w-fit flex-col gap-1 rounded-xl border border-gray-200 bg-white p-4">
			<Heading mode="secondary">{room.name}</Heading>
			<Code className="text-xs">{room.id}</Code>
			<table className="w-fit">
				<tbody>
					<tr>
						<td className="pr-2 text-left text-sm text-gray-700">Repair Time:</td>
						<td>
							<TimeDisplay timeSeconds={room.repairTime} />
						</td>
					</tr>
					<tr>
						<td className="pr-2 text-left text-sm text-gray-700">Activation Codes:</td>
						<td>{room.activationCodes.join(', ')}</td>
					</tr>
					<tr>
						<td className="pr-2 text-left text-sm text-gray-700">Repair Codes:</td>
						<td>{room.repairCodes.join(', ')}</td>
					</tr>
				</tbody>
			</table>
		</div>
	);
}

function TimeDisplay({ timeSeconds }: { timeSeconds: number }) {
	const hours = Math.floor(timeSeconds / 3600);
	const minutes = Math.floor((timeSeconds % 3600) / 60);
	const seconds = timeSeconds % 60;

	let display = '';
	if (hours > 0) display += `${hours}h`;
	if (minutes > 0) display += `${minutes}m`;
	if (seconds > 0) display += `${seconds}s`;
	if (!display) display = '0s';

	return <span>{display}</span>;
}
